<xemex-authorization-container [isLoading]="store.isLoading()">
  <div class="flex flex-col gap-6">
    <header class="flex flex-col gap-1">
      <h1 class="text-2xl font-bold">{{ 'login.title' | translate }}</h1>
      <p class="text-sm text-neutral">
        {{ 'login.subtitle' | translate: { company: companyName } }}
      </p>
    </header>

    @if (store.authFeedback(); as feedback) {
      <xemex-alert-banner [variant]="feedback.variant">
        {{ feedback.key | translate }}
      </xemex-alert-banner>
    }

    <form class="flex flex-col gap-4" [formGroup]="loginForm" (submit)="onSignIn()">
      <xemex-text-field
        formControlName="username"
        type="email"
        prefixIcon="person"
        autocomplete="email"
        [label]="'login.form.email' | translate"
        [placeholder]="'login.form.placeholderEmail' | translate"
        [invalid]="usernameCtrl.invalid && usernameCtrl.touched"
        [errorText]="
          usernameCtrl.hasError('required')
            ? ('error.required' | translate: { field: 'login.form.email' | translate })
            : usernameCtrl.hasError('email')
              ? ('error.emailInvalid' | translate)
              : ''
        "
      />

      <div class="flex flex-col gap-1.5">
        <xemex-text-field
          formControlName="password"
          type="password"
          prefixIcon="lock"
          autocomplete="current-password"
          [label]="'login.form.password' | translate"
          [placeholder]="'login.form.placeholderPassword' | translate"
          [invalid]="passwordCtrl.invalid && passwordCtrl.touched"
          [errorText]="
            passwordCtrl.hasError('required')
              ? ('error.required' | translate: { field: 'login.form.password' | translate })
              : ''
          "
        />
        <div class="text-end">
          <a
            [href]="'/' + APP_PATHS.Auth + '/' + APP_PATHS.ResetPassword"
            class="text-sm font-semibold text-primary hover:underline"
          >
            {{ 'login.forgotPassword' | translate }}
          </a>
        </div>
      </div>

      <xemex-filled-button type="submit" [fullWidth]="true" [loading]="store.isLoading()">
        {{ 'login.btnSignIn' | translate }}
      </xemex-filled-button>
    </form>

    <div class="flex items-center gap-3 text-sm text-neutral">
      <span class="h-px flex-1 bg-surface-card-border"></span>
      {{ 'general.or' | translate }}
      <span class="h-px flex-1 bg-surface-card-border"></span>
    </div>

    <xemex-tonal-button icon="shield" [fullWidth]="true" (click)="login()">
      {{ 'login.btnXemexSignIn' | translate }}
    </xemex-tonal-button>

    <div class="flex flex-row flex-wrap justify-center gap-1.5">
      <button
        type="button"
        class="text-sm text-neutral hover:underline cursor-pointer"
        (click)="onViewTerms()"
      >
        {{ 'login.terms.title' | translate }}
      </button>
      <span class="text-neutral text-sm">&#8226;</span>
      <a
        [href]="privacyPolicyLink"
        target="_blank"
        class="text-sm text-neutral hover:underline"
      >
        {{ 'general.privacyPolicy' | translate }}
      </a>
    </div>
  </div>
</xemex-authorization-container>
